// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventParticipantEntity from './entities/event-participant.json';
import eventParticipantMenu from '../pages/event-participant/menu.json';
import eventParticipantFullForm from '../pages/event-participant/forms/full.json';
import eventParticipantContextForm from '../pages/event-participant/forms/context.json';
import eventParticipantMiniForm from '../pages/event-participant/forms/mini.json';
import eventParticipantLookupForm from '../pages/event-participant/forms/lookup.json';
import eventParticipantTableView from '../pages/event-participant/views/table.json';
import eventParticipantCardsView from '../pages/event-participant/views/cards.json';
import eventParticipantDashboardView from '../pages/event-participant/views/dashboard.json';

/** Тип запису «Учасник події» зі сторінками пакета: меню, форми та подання з pages/event-participant/. */
export const eventParticipantDefinition: IRecordTypeDefinition = {
  ...eventParticipantEntity,
  views: assembleViewSet({
      table: eventParticipantTableView,
      cards: eventParticipantCardsView,
      dashboard: eventParticipantDashboardView,
  }),
  form: eventParticipantFullForm,
  forms: { full: eventParticipantFullForm, context: eventParticipantContextForm, mini: eventParticipantMiniForm, lookup: eventParticipantLookupForm },
  menu: eventParticipantMenu,
} as IRecordTypeDefinition;
